(function($, undefined) {
	
	'use strict';
    var filterBox;
    var archiveBtn;
    var approveTaxBtn;
    var cancelRefBtn;
    var acceptRefundBtn;
    var transferBtn;
    var eventRefundAmount;
    var shipTicketsBtn;
    var shipTicketsFromPayBtn;
    var rebillBtn;
    var approveAppBtn;
    var refuseAppBtn;
    var tools;
    
    var filterBy = function(){
        var t = $(this);
       t.closest("form").submit();
    };
    
    var archiveAlert = function(){
      var t = $(this);
      var id = t.attr("data-id");
      var archived = t.hasClass("archived");
      t.addClass("disabled");
      
      var url = "/action/epManageAlerts";
      url += "?ajax=true";
      url += "&id="+id;
      url += "&archive="+!archived;
      
      ajax(url, function(){
          t.closest("tr").addClass("toggle-archive-selected");
          window.setTimeout(function(){
                var cl = t.closest("tr").clone(true);
                t.closest("tr").find("td").slideUp(function() {
                    var text = "";
                    if (archived) {
                        cl.find(".table-alerts-list-archive-action").removeClass("archived");
                        text = cl.find(".table-alerts-list-archive-action").find("p").attr("data-archive");
                        cl.find(".table-alerts-list-archive-action").find("p").html(text);
                        cl.insertAfter('.not-archive-table-list tr:first');
                    }
                    else {
                        cl.find(".table-alerts-list-archive-action").addClass("archived");
                        text = cl.find(".table-alerts-list-archive-action").find("p").attr("data-unarchive");
                        cl.find(".table-alerts-list-archive-action").find("p").html(text);
                        cl.insertAfter('.archive-table-list tr:first');
                    }
                    
                    cl.removeClass("toggle-archive-selected");
                    cl.find("button.disabled").removeClass("disabled");
                    $(this).parent().remove();
                }); 
          },1000);
      },true);
    };
    
    var approveTax = function() {
        var t = $(this);
        var id = t.attr("data-id");
        var accepted = t.hasClass("accepted");
        t.addClass("disabled");

        var url = "/action/updatePersonFields";
        url += "?ajax=true";
        url += "&id=" + id;
        url += "&field18=" + !accepted;

        ajax(url, function() {
            var text = "";
            if (accepted) {
                t.removeClass("accepted");
                text = t.find("p").attr("data-approve");
                t.find("p").html(text);
            }
            else {
                t.addClass("accepted");
                text = t.find("p").attr("data-approved");
                t.find("p").html(text);
            }
            t.removeClass("disabled");
        }, true);
    };
       
    /* Request for refund already created : this cancels it. */
    var cancelRefundPaymentFromAlert = function(){
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");
        var url = "/action/epRefund?ajax=true";
        url += "&cancel=true";
        if (id !== '-1') {
            url += "&paymentId=" + id;
        } else if (id === '-1') {
            url += '&alertId=' + t.closest('tr').attr('data-id');
        }

        ajax(url, function(response) {
            t.addClass("canceled");
            t.closest(".table-alerts-actions").find(".table-alerts-list-approve-refund-action").addClass("disabled");
            var text = t.find("p").attr("data-canceled");
            t.find("p").html(text);
        }, true);
    };
    
    /* Request for refund already created : accept it. */
    var acceptRefundPaymentFromAlert = function(){
        var t = $(this);
        t.addClass("disabled");
        var id = t.attr("data-id");
        var url = "/action/epRefund?ajax=true";
        if (id !== '-1') {
            url += "&paymentId=" + id;
        } else if (id === '-1') {
            url += '&accept=true&alertId=' + t.closest('tr').attr('data-id');
        }

        ajax(url, function(response) {
            t.addClass("accepted");
            t.closest(".table-alerts-actions").find(".table-alerts-list-cancel-refund-action").addClass("disabled");
            var text = t.find("p").attr("data-approved");
            t.find("p").html(text);
        }, true);
    };

    var updateShippedTickets = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var post = true;

        if (t.hasClass('shipped')) {
            post = false;
        }

        var url = "/action/epManageAlerts?ajax=true";
        url += "&id=" + id;
        url += "&post=" + post;

        
        ajax(url, function(response) {
            if (t.hasClass('shipped')) {
                t.removeClass("shipped");
                var text = t.find("p").attr("data-ship");
            } else {
                t.addClass("shipped");
                var text = t.find("p").attr("data-shipped");
            }
            t.find("p").html(text);
        }, true);
    };
    
    var updateShippedTicketsFromPayment = function(){
        var t = $(this);
        var id = t.attr("data-id");
        var post = true;

        if (t.hasClass('shipped')) {
            post = false;
        }

        var url = "/action/epManageTransactions?ajax=true";
        url += "&paymentId=" + id;
        url += "&post=" + post;

        ajax(url, function(response) {
            var cell = t.closest("tr").find(".transaction-detail span");
            var text = "";
            var cellText = "";
            if (t.hasClass('shipped')) {
                t.removeClass("shipped");
                text = t.find("p").attr("data-ship");
                cellText = cell.attr("data-ship");
            } else {
                t.addClass("shipped");
                text = t.find("p").attr("data-shipped");
                cellText = cell.attr("data-shipped");
            }
            t.find("p").html(text);
            cell.html(cellText);
        }, true);
    };
    
    var transferPayment = function(){
        var t = $(this);
        var line = t.closest(".alert-line");
        var ctn = t.closest(".claim-payment-popup");
        var input = ctn.find(".claim-amt-payment");
        var amt = input.val();
        var id = t.attr("data-id");

        formValidator.validateForm(ctn);
        t.addClass("disabled");
        
        if (!ctn.hasClass('has-error')) {
            var url = "/action/epManageAlerts";
            url += "?ajax=true";
            url += "&id="+id;
            url += "&field2=true";
            url += "&field5=" + amt;

            ajax(url, function() {
                line.find(".sum-transfered").html(amt+ "$");
                line.find(".table-alerts-list-accept-transfer-action").addClass("accepted").addClass("disabled");
                var text = line.find(".table-alerts-list-accept-transfer-action p").attr("data-accepted");
                line.find(".table-alerts-list-accept-transfer-action p").html(text);

            }, true);
        }
    };

    var getEventRefundAmounts = function() {
        eventRefundAmount.each(function() {
            var t = $(this);

            var url = '/action/epRefund';
            url += '?eventId=' + t.attr('data-id');
            url += '&data=true&ajax=true';
            ajax(url, function(response) {
                t.find('.amount').html(parseFloat(response.split('~')[0]).toFixed(2));
                t.find('.consignes').html(response.split('~')[4]);
            }, true);
        });
    };
    
    var rebillAction = function(){
        var t = $(this);
        var ctn = t.closest(".js-form");
        var input = ctn.find(".rebill-input-amt input");
        var amt = input.val();
        var profileId = ctn.find("input[name=profileId]").val();
        var alertId =  ctn.find("input[name=alertId]").val();
        var personId =  ctn.find("input[name=personId]").val();
        var btn = t.closest("tr").find(".table-alerts-list-re-bill-action");
        var zeroOrUnderError = $('.js-form-error-message.requested-amount-zero-or-under', ctn);
        var fail = $('.fail-msg', ctn);
        var success = $('.js-form-success-message', ctn);


        formValidator.validateForm(ctn);
        
        if (!ctn.hasClass('has-error')) {
            t.addClass("disabled");
            if (parseFloat(amt) <= 0) {
                t.removeClass("disabled");
                zeroOrUnderError.slideDown();
            } else {
                var url = "/action/epMonthlyPayments";
                url += "?alertId=" + alertId;
                url += "&profileId=" + profileId;
                url += "&personId=" + personId;
                url += "&amt=" + amt;

                ajax(url, function (response) {
                    t.removeClass("disabled");
                    if (response.trim() === "null") {
                        btn.addClass("accepted");
                        btn.find("p").text(btn.find("p").attr("data-accepted"));
                        success.slideDown();
                    } else {
                        fail.slideDown();
                    }
                }, true);
            }
        }
        
        
    };
    
    var approveApp = function() {
        var t = $(this);
        var refuseBtn = $(this).closest(".admin-alerts-actions").find(".table-alerts-list-refuse-app");
        var id = t.attr("data-id");
        var appId = t.attr("data-gid");
		var lang = $("html").attr('lang');
        var email = t.attr('data-email');
        var alreadyApproved = t.hasClass("accepted");

        var url = "/action/manageGenData";
        url += "?ajax=true";
        url += "&id=" + appId;
        url += "&field2=2";

        ajax(url, function () {
            var url2 = "/action/epManageAlerts";
            url2 += "?ajax=true";
            url2 += "&id=" + id;
            url2 += "&field2=true";
            url2 += "&field3=false";
            ajax(url2, function () {
                var text = "";
                t.addClass("accepted");
                text = t.find("p").attr("data-approved");
                t.find("p").html(text);
                t.removeClass("disabled");
                
                refuseBtn.removeClass("refused");
                text = refuseBtn.find("p").attr("data-refuse");
                refuseBtn.find("p").html(text);
                
                if(!alreadyApproved){
                    var subject = lang === "fr" ? "Votre demande pour une application mobile a été acceptée!" : "Your request for a mobile app has been approved!";
                    tools.sendEmail(email, subject, null, "app-approved-" + lang, null, function (response) {
                    });
                }

            }, true);
        }, true);
    };
    
    var refuseApp = function() {
        var t = $(this);
        var id = t.attr("data-id");
        var appId = t.attr("data-gid");
        var acceptBtn = $(this).closest(".admin-alerts-actions").find(".table-alerts-list-validate-app");
        var email = t.attr('data-email');
		var lang = $("html").attr('lang');
        var alreadyRefused = t.hasClass("refused");

        var url = "/action/manageGenData";
        url += "?ajax=true";
        url += "&id=" + appId;
        url += "&field2=3";

        ajax(url, function () {
            var url2 = "/action/epManageAlerts";
            url2 += "?ajax=true";
            url2 += "&id=" + id;
            url2 += "&field2=false";
            url2 += "&field3=true";
            ajax(url2, function () {
                var text = "";
                t.addClass("refused");
                text = t.find("p").attr("data-refused");
                t.find("p").html(text);
                t.removeClass("disabled");
                
                acceptBtn.removeClass("accepted");
                text = acceptBtn.find("p").attr("data-approve");
                acceptBtn.find("p").html(text);
                
                if (!alreadyRefused) {
                    var subject = lang === "fr" ? "Votre demande pour une application mobile a été refusée" : "Your request for a mobile app has been denied";
                    tools.sendEmail(email, subject, null, "app-refused-" + lang, null, function (response) {
                    });
                }

            }, true);
        }, true);
    };
    
	var init = function (page) {
        tools = Fw.component.models().tools;
		filterBox = $(".filter-alerts-select");        
        filterBox.on("change",filterBy);
        
		archiveBtn = $(".table-alerts-list-archive-action");        
        archiveBtn.on("click",archiveAlert);
        
		approveTaxBtn = $(".table-alerts-list-validate-tax-action");        
        approveTaxBtn.on("click",approveTax);
        
		cancelRefBtn = $(".table-alerts-list-cancel-refund-action:not(.canceled)");        
        cancelRefBtn.on("click",cancelRefundPaymentFromAlert);
        
		acceptRefundBtn = $(".table-alerts-list-approve-refund-action:not(.accepted)");        
        acceptRefundBtn.on("click",acceptRefundPaymentFromAlert);
        
        transferBtn = $(".make-payment-confirm-btn");
        transferBtn.on("click", transferPayment);

        eventRefundAmount = $('.event-refund-amount, .event-refund-consignes');

        if (eventRefundAmount.length) {        
            getEventRefundAmounts();
        }

        shipTicketsBtn = $('.table-alerts-list-ship-consigne-action');
        shipTicketsBtn.click(updateShippedTickets);

        shipTicketsFromPayBtn = $('.table-transactions-list-ship-consigne-action');
        shipTicketsFromPayBtn.click(updateShippedTicketsFromPayment);
        
        rebillBtn = $('.submit-rebill-btn');
        rebillBtn.click(rebillAction);
        
		approveAppBtn = $(".table-alerts-list-validate-app");        
        approveAppBtn.on("click", approveApp);
        
		refuseAppBtn = $(".table-alerts-list-refuse-app");        
        refuseAppBtn.on("click", refuseApp);
        

	};

	$(window).on("load",function(){
		init();
	});
	
})(jQuery);
